import { tint, lighten, darken } from "polished"
import { marketoInputShadow } from "./globals"
import * as colors from "./colors"
// import { shadow, shadowSoft } from 'src/styles/globals'

// Themes (ThemeSelector Component)
export const themes = {
	default: {
		color: colors.textColor,
		background: colors.bgColor,
		hoverColor: colors.mainColor,
		buttonTheme: 'default',
		buttonThemeSecondary: 'lightGrey'
	},
	lightGrey: {
		color: colors.textColor,
		lightColor: colors.lightTextColor,
		background: colors.lightGrey,
		hoverColor: colors.textColor,
		buttonTheme: 'default',
		buttonThemeSecondary: 'white'
	},
	mainColor: {
		color: colors.bgColor,
		lightColor: colors.bgColor,
		background: colors.mainColor,
		hoverColor: colors.bgColor,
		buttonTheme: 'white',
		buttonThemeSecondary: 'lightGrey',
		hrColor: tint(0.3, colors.mainColor),
		mainColor: colors.bgColor
	},
	lightBlue: {
		color: colors.navy,
		lightColor: colors.navy,
		background: colors.lightBlue,
		hoverColor: colors.navy,
		buttonTheme: 'white',
		buttonThemeSecondary: 'lightGrey',
	},
	blueGreen: {
		color: colors.white,
		lightColor: colors.white,
		background: colors.easternBlue,
		hoverColor: colors.white,
		buttonTheme: 'textColor',
		buttonThemeSecondary: 'white'
	},
	greenBright: {
		color: colors.navy,
		lightColor: colors.navy,
		background: colors.turquoise,
		hoverColor: colors.navy,
		buttonTheme: 'textColor',
		buttonThemeSecondary: 'white'
	},
	textColor: {
		color: colors.extraLightGrey,
		lightColor: colors.extraLightGrey,
		background: colors.textColor,
		hoverColor: colors.white,
		buttonTheme: 'mainColor',
		buttonThemeSecondary: 'white'
	},
	heliotrope: {
		color: colors.white,
		lightColor: colors.white,
		background: colors.heliotrope,
		hoverColor: colors.white,
		buttonTheme: 'textColor',
		buttonThemeSecondary: 'white'
	},
	onahau: {
		color: colors.navy,
		lightColor: colors.navy,
		background: colors.onahau,
		hoverColor: colors.navy,
		buttonTheme: 'textColor',
		buttonThemeSecondary: 'white'
	},
	yellow: {
		color: colors.navy,
		lightColor: colors.navy,
		background: colors.mustardYellow,
		hoverColor: colors.navy,
		buttonTheme: 'textColor',
		buttonThemeSecondary: 'white'
	},
  lightYellow: {
		color: colors.navy,
		lightColor: colors.navy,
		background: colors.lightYellow,
		hoverColor: colors.navy,
		buttonTheme: 'textColor',
		buttonThemeSecondary: 'white'
	}
}

// Button Themes
export const buttonThemes = {
	default: {
		color: colors.bgColor,
		background: colors.mainColor,
		hoverColor: colors.bgColor,
		hoverBackground: lighten(0.07, colors.mainColor),
	},
	transparent: {
		color: colors.lightTextColor,
		background: 'transparent',
		hoverColor: colors.textColor,
		hoverBackground: 'transparent',
		shadow: 'none',
		hoverShadow: 'none'
	},
	currentcolor: {
		color: colors.textColor,
		background: 'currentcolor',
		hoverColor: 'currentcolor',
		hoverBackground: 'currentcolor',
	},
	currentcolorOutlined: {
		color: 'currentcolor',
		background: 'transparent',
		hoverColor: colors.textColor,
		hoverBackground: 'currentcolor',
		borderColor: 'currentcolor',
	},
	black: {
		color: colors.bgColor,
		background: colors.black,
		hoverColor: colors.mainColor,
		hoverBackground: darken(0.07, colors.mainColor),
	},
	white: {
		color: colors.textColor,
		background: colors.white,
		hoverColor: colors.mainColor,
		hoverBackground: colors.lightGrey,
	},
	lightGrey: {
		color: colors.textColor,
		background: colors.lightGrey,
		hoverColor: colors.textColor,
		hoverBackground: darken(0.07, colors.lightGrey),
	},
	mainColor: {
		color: colors.bgColor,
		background: colors.mainColor,
		hoverColor: colors.bgColor,
		hoverBackground: lighten(0.07, colors.mainColor),
	},
	textColor: {
		color: colors.bgColor,
		background: colors.textColor,
		hoverColor: colors.bgColor,
		hoverBackground: colors.mainColor,
	}
}

// Input Themes
export const inputThemes = {
	default: {
		color: colors.textColor,
		placeholderColor: colors.lightTextColor,
		background: colors.white,
		accentColor: colors.mainColor,
		hoverColor: colors.textColor,
		borderColor: colors.white,
		hoverBorderColor: colors.white,
		focusBorderColor: colors.white,
		hoverBackground: colors.white,
		focusBackground: colors.white,
	},
	lightGrey: {
		color: colors.textColor,
		placeholderColor: colors.lightTextColor,
		background: colors.extraLightGrey,
		accentColor: colors.mainColor,
		hoverColor: colors.textColor,
		borderColor: colors.lightGrey,
		hoverBorderColor: colors.lightGrey,
		focusBorderColor: colors.lightGrey,
		hoverBackground: colors.extraLightGrey,
		focusBackground: colors.extraLightGrey,
	},
	grey: {
		color: colors.textColor,
		placeholderColor: colors.lightTextColor,
		background: colors.lightGrey,
		accentColor: colors.mainColor,
		hoverColor: colors.textColor,
		borderColor: colors.lightGrey,
		hoverBorderColor: colors.lightGrey,
		focusBorderColor: colors.lightGrey,
		hoverBackground: colors.lightGrey,
		focusBackground: colors.lightGrey,
		shadow: marketoInputShadow(0.25),
		hoverShadow: marketoInputShadow(0.35),
		focusShadow: marketoInputShadow(0.35),
	},
	white: {
		color: colors.textColor,
		placeholderColor: colors.lightTextColor,
		background: colors.white,
		accentColor: colors.mainColor,
		hoverColor: colors.textColor,
		borderColor: colors.white,
		hoverBorderColor: colors.white,
		focusBorderColor: colors.white,
		hoverBackground: colors.white,
		focusBackground: colors.white,
		shadow: marketoInputShadow(0.45),
		hoverShadow: marketoInputShadow(0.55),
		focusShadow: marketoInputShadow(0.55),
	}
}

export default themes
